import { jsxs as g, jsx as m, Fragment as L } from "react/jsx-runtime";
import x from "react";
import { u as d } from "./index-6a632112.mjs";
import { b, Q as y, r as a, s as e, a as u, d as C, h as z, e as w, B as H } from "./themes-5f0b3c3d.mjs";
import { l as T } from "./lineHeights-72d3110c.mjs";
import { a as P, b as B, c as F } from "./superScript-393c70dc.mjs";
import { C as Y } from "./ChildrenCountCheck-60cafda6.mjs";
import { AspectRatio as D } from "./aspectRatio.js";
import { TagsGroup as M, Tag as G } from "./tags.js";
import { S as U } from "./playFilled-b880efda.mjs";
import { IconButton as W } from "./iconButton.js";
import { Disclosures as j } from "./disclosure.js";
import { h as _ } from "./hTag-40b23797.mjs";
import { MediaDisclosureButton as k } from "./mediaDisclosureButton.js";
import { useWindowDimensions as V } from "./useWindowDimensions.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./button.js";
import "./accessibility.js";
import "./zIndices-d07533f3.mjs";
const i = {
  TYPE_DEFAULT: "default",
  TYPE_GHOST: "ghost",
  ORIENTATION_HORIZONTAL: "horizontal",
  ORIENTATION_VERTICAL: "vertical",
  RATIO_1_TO_1: "1/1",
  RATIO_16_TO_9: "16/9"
}, Q = 5, X = d.div`
  ${P()}
  ${B()}
  display: flex;
  height: ${({ $fullHeight: t }) => t ? "100%" : "auto"};
  box-shadow: ${(t) => t.$cardType === i.TYPE_DEFAULT ? `0px ${b["2x"]} ${b["8x"]} 0px rgba(0, 0, 0, 0.1)` : "none"};
  background-color: ${(t) => t.$cardType === i.TYPE_DEFAULT ? t.theme.components.card.cardBackground : "transparent"};
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  @media ${y.tabletAndUp} {
    flex-direction: ${(t) => t.$orientation === i.ORIENTATION_VERTICAL ? "column" : "row"};

    color: ${(t) => t.$cardType === i.TYPE_DEFAULT ? t.theme.components.card.contentColor : t.theme.components.card.ghostContentColor};
  }

  .media {
    width: 100%;
  }

  border-radius: ${a["2x"]};
  border: ${(t) => t.$cardType === i.TYPE_DEFAULT ? `${b["1x"]} solid var(--neutral-400, ${t.theme.components.card.borderColor})` : "none"};
`, Z = d.div`
  height: ${({ $cardType: t }) => t === "ghost" ? "fit-content" : "auto"};
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;

  & > * {
    border-radius: ${`${a["2x"]} ${a["2x"]} ${a["0x"]} ${a["0x"]}`};
    & > * {
      border-radius: inherit;
    }
  }

  .ghost & > * {
    border-radius: ${a["2x"]};
    & > * {
      border-radius: inherit;
    }
  }

  &:hover {
    ${(t) => t.onClick && "cursor: pointer"};
  }
  @media ${y.tabletAndUp} {
    .horizontal & > * {
      border-radius: ${`${a["2x"]} ${a["0x"]} ${a["0x"]} ${a["2x"]}`};
    }

    .horizontal.right & > * {
      border-radius: ${`${a["0x"]} ${a["2x"]} ${a["2x"]} ${a["0x"]}`};
    }

    .ghost.horizontal & > * {
      border-radius: ${a["2x"]};
    }
  }
`, K = (t, n, r, l) => {
  const o = {
    left: "0px",
    right: "0px",
    top: "0px",
    bottom: "0px"
  }, c = () => {
    r ? (o.top = "unset", o.right = e["6x"]) : (o.top = "unset", o.left = e["6x"]);
  }, s = () => {
    l === i.RATIO_1_TO_1 ? (o.top = e["8x"], o.bottom = e["8x"]) : (o.top = e["12x"], o.bottom = e["12x"]);
  };
  return t === i.TYPE_GHOST ? n === i.ORIENTATION_VERTICAL ? (o.top = e["4x"], o.bottom = "0px") : c() : n === i.ORIENTATION_VERTICAL ? (o.top = e["8x"], o.bottom = e["8x"], o.left = e["8x"], o.right = e["8x"]) : (o.left = e["9x"], o.right = e["9x"], s()), o;
}, q = d.div`
  width: 100%;
  box-sizing: border-box;
  color: ${(t) => t.$cardType === i.TYPE_GHOST ? t.theme.components.card.ghostContentColor : t.theme.components.card.contentColor};
  ${(t) => {
  let n = e["8x"], r = e["8x"], l = e["8x"], o = e["8x"];
  return t.$cardType === i.TYPE_GHOST && (n = "0px", r = "0px", l = e["4x"], o = "0px"), {
    paddingLeft: n,
    paddingRight: r,
    paddingBottom: o,
    paddingTop: l
  };
}}
  @media ${y.tabletAndUp} {
    ${(t) => {
  const n = K(
    t.$cardType || i.TYPE_DEFAULT,
    t.$orientation || i.ORIENTATION_HORIZONTAL,
    t.$right || !1,
    t.$ratio || i.RATIO_1_TO_1
  );
  return {
    paddingLeft: n?.left,
    paddingRight: n?.right,
    paddingBottom: n?.bottom,
    paddingTop: n?.top
  };
}}
  }
`, J = d(_)`
  font-size: ${({ $titleSize: t }) => t === "large" ? u.xxlarge : u.xxxxlarge};
  font-family: ${C.headline};
  font-weight: ${z.XL.fontWeight};
  line-height: ${({ $titleSize: t }) => t === "large" ? T.xlarge : T.xxlarge};
  margin-bottom: ${e["3x"]};
  color: ${(t) => t.$cardType === i.TYPE_GHOST ? t.theme.components.card.ghostTitleColor : t.theme.components.card.titleColor};
`, tt = d.div`
  margin-bottom: ${e["3x"]};
`, et = d(_)`
  font-size: ${u.small};
  font-family: ${C.body};
  font-weight: ${w.semiBold.M.fontWeight};
  line-height: ${T.small};
  margin-bottom: ${e["3x"]};
  color: ${(t) => t.$cardType === i.TYPE_GHOST ? t.theme.components.card.ghostContentColor : t.theme.components.card.contentColor};
`, ot = ({
  children: t,
  headingLevel: n = "h2",
  cardType: r
}) => /* @__PURE__ */ m(et, { as: n, $cardType: r, children: t }), rt = d.div`
  ${F()}
  font-size: ${u.small};
  font-family: ${C.body};
  line-height: ${T.medium};
  & {
    color: ${(t) => t.$cardType === i.TYPE_GHOST ? t.theme.components.card.ghostContentColor : t.theme.components.card.contentColor};
  }
`, nt = d.div`
  margin-top: ${e["6x"]};
`, it = d.div`
  margin-top: ${e["6x"]};
  display: flex;
  flex-wrap: wrap;
  gap: ${e["3x"]};
`, at = d.div`
  margin-top: ${e["6x"]};
`, lt = d(W)`
  && {
    position: absolute;
    z-index: 0;
    width: ${e["10x"]};
    height: ${e["10x"]};
    top: auto;
    left: ${e["6x"]};
    bottom: ${e["6x"]};
    svg {
      top: auto;
      left: auto;
    }
    > span {
      justify-content: center;
      align-items: center;
    }
  }
`, dt = d.div`
  position: absolute;
  top: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    ${(t) => t.theme.components.card.gradientOverlayStartColor} 0%,
    ${(t) => t.theme.components.card.gradientOverlayEndColor} 100%
  );
  z-index: 0;
`, h = ({
  orientation: t = "vertical",
  className: n = "",
  cardType: r = "default",
  children: l,
  ratio: o = "1/1",
  right: c = !1,
  titleProp: s = { size: "extraLarge", title: "", headingLevel: "h1" },
  disclosures: p,
  fullHeight: S = !0
}) => {
  let f = null, E = null;
  const O = V().width < H.tabletMin - 1, R = x.Children.map(l, ($, st) => {
    if ($ && x.isValidElement($)) {
      if ($.type === A) {
        const N = $.props;
        return f = x.cloneElement($, {
          children: N.children,
          _ratio: o,
          cardType: r
        }), null;
      } else if ($.type === v || $.type === I)
        return E = $, null;
      return x.cloneElement($, { $cardType: r });
    }
    return null;
  });
  return /* @__PURE__ */ g(
    X,
    {
      $orientation: t,
      className: `${n} ${t} ${r} ${c ? "right" : ""}`,
      $cardType: r,
      $right: c,
      $ratio: o,
      $title: s.title,
      $fullHeight: S,
      children: [
        t === "horizontal" && c && !O ? null : f,
        /* @__PURE__ */ g(
          q,
          {
            $cardType: r,
            $ratio: o,
            $orientation: t,
            $right: c,
            $title: s.title,
            children: [
              E,
              s?.title && /* @__PURE__ */ m(
                J,
                {
                  as: s.headingLevel,
                  $cardType: r,
                  $titleSize: s?.size,
                  children: s.title
                }
              ),
              R,
              p && /* @__PURE__ */ m(
                j,
                {
                  disclosureContent: p?.disclosureContent,
                  id: p?.id,
                  className: p?.className,
                  disclosureTitleColor: p?.disclosureTitleColor,
                  style: p?.style
                }
              )
            ]
          }
        ),
        t === "horizontal" && c && !O && f
      ]
    }
  );
}, A = ({
  _ratio: t = "1/1",
  children: n,
  className: r = "",
  shouldShowPlayButton: l = !1,
  onClick: o,
  shouldShowOverlay: c = !1,
  disclosureLinks: s,
  cardType: p = "default"
}) => /* @__PURE__ */ g(
  Z,
  {
    className: `${r}`,
    $cardType: p,
    onClick: o,
    children: [
      /* @__PURE__ */ g(D, { ratio: t, objectFit: "cover", className: "media", children: [
        n,
        c && /* @__PURE__ */ m(dt, {}),
        l && /* @__PURE__ */ m(lt, { icon: /* @__PURE__ */ m(U, {}), onClick: o })
      ] }),
      s && /* @__PURE__ */ m(
        k,
        {
          ...s,
          alignment: "bottom-right",
          containerPosition: { bottom: "8px", right: "24px" }
        }
      )
    ]
  }
), I = ({
  overflowVariant: t = "default",
  overflow: n = !1,
  children: r = [],
  onClick: l
}) => r ? /* @__PURE__ */ g(L, { children: [
  /* @__PURE__ */ m(
    Y,
    {
      additionalInfo: "Maximun tags count exceeded. Max 5 tags allowed in a group for cards.",
      children: r,
      componentName: "card",
      maxChildren: Q
    }
  ),
  /* @__PURE__ */ m(
    M,
    {
      overflow: n,
      overflowVariant: t,
      onClick: l,
      "data-testid": "child",
      children: r
    }
  )
] }) : null, v = ({
  title: t,
  children: n,
  className: r = "",
  variant: l = "default"
}) => t ? /* @__PURE__ */ g(tt, { className: r, children: [
  /* @__PURE__ */ m(G, { title: t, variant: l }),
  n
] }) : null;
h.Media = A;
h.Tag = v;
h.SubTitle = ot;
h.TagGroup = I;
h.BodyContent = rt;
h.BodySlot = nt;
h.Footer = it;
h.FooterLink = at;
export {
  h as Card
};
